import { render, staticRenderFns } from "./registItem.vue?vue&type=template&id=3371ad69&scoped=true&"
import script from "./registItem.vue?vue&type=script&lang=js&"
export * from "./registItem.vue?vue&type=script&lang=js&"
import style0 from "./registItem.vue?vue&type=style&index=0&id=3371ad69&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3371ad69",
  null
  
)

export default component.exports